<template>
  <header class="sh-header" :style="{ paddingBottom: headerPaddingBottom + 'px' }">
    <div class="sh-container">
      <!-- 使用图片替换整个头部内容 -->
      <div class="sh-header-content">
        <img class="sh-header-image" src="/header.png" alt="网站头部" />
      </div>
    </div>
    <!-- 全局导航栏 -->
    <div class="section_1 flex-row" ref="navBar">
      <span class="text_3 nav-item" ref="navHome" @click="navigateToHome" style="cursor: pointer;">首页</span>
      <span class="text_4 nav-item" ref="navIntro" @click="navigateToIntro" style="cursor: pointer;">成果简介</span>
      <div class="dropdown-container content-dropdown" :class="{ 'active-parent': showDropdown }" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
        <span class="text_5 nav-item" ref="navContent" style="cursor: pointer;">成果内容</span>
        <div class="dropdown-menu" v-show="showDropdown" :style="contentMenuInlineStyle" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <div class="dropdown-item" @click="navigateToDetail('课程资源')">课程资源</div>
          <div class="dropdown-item" @click="navigateToDetail('竞赛引领')">竞赛引领</div>
          <div class="dropdown-item" @click="navigateToDetail('数智融合')">数智融合</div>
          <div class="dropdown-item" @click="navigateToDetail('证书赋能')">证书赋能</div>
          <div class="dropdown-item" @click="navigateToDetail('双师团队')">双师团队</div>
          <div class="dropdown-item" @click="navigateToDetail('文化浸润')">文化浸润</div>
          <div class="dropdown-item" @click="navigateToDetail('资源辐射')">资源辐射</div>
          <div class="dropdown-item" @click="navigateToDetail('实训基地')">实训基地</div>
        </div>
      </div>
      <span class="text_6 nav-item" ref="navFeature" @click="navigateToFeature" style="cursor: pointer;">成果特色</span>
      <div class="dropdown-container value-dropdown" :class="{ 'active-parent': showValueDropdown }" @mouseenter="showValueDropdown = true" @mouseleave="showValueDropdown = false">
        <span class="text_7 nav-item" ref="navValue" style="cursor: pointer;">成果价值</span>
        <div class="dropdown-menu" v-show="showValueDropdown" :style="valueMenuInlineStyle" @mouseenter="showValueDropdown = true" @mouseleave="showValueDropdown = false">
          <div class="dropdown-item" @click="navigateToValue('德技双馨')">德技双馨</div>
          <div class="dropdown-item" @click="navigateToValue('教学示范')">教学示范</div>
          <div class="dropdown-item" @click="navigateToValue('服务社会')">服务社会</div>
          <div class="dropdown-item" @click="navigateToValue('引领示范')">引领示范</div>
        </div>
      </div>
      <span class="text_8 nav-item" ref="navPromotion" @click="navigateToPromotion" style="cursor: pointer;">成果推广</span>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      showDropdown: false,
      showValueDropdown: false,
      headerPaddingBottom: 0,
      contentMenuShift: 12,
      valueMenuShift: 10,
    };
  },
  computed: {
    contentMenuInlineStyle() {
      return { transform: `translateX(calc(-50% + ${this.contentMenuShift}px))` };
    },
    valueMenuInlineStyle() {
      return { transform: `translateX(calc(-50% + ${this.valueMenuShift}px))` };
    }
  },
  methods: {
    navigateToHome() {
      this.$router.push('/lanhu/shouye');
    },
    navigateToIntro() {
      this.$router.push('/lanhu/chengguojianjie');
    },
    navigateToDetail(type) {
      this.$router.push({ path: '/lanhu/wenzhangxiangqing', query: { type } });
      this.showDropdown = false;
    },
    navigateToValue(type) {
      this.$router.push({ path: '/lanhu/chengguojiazhi', query: { type } });
      this.showValueDropdown = false;
    },
    navigateToPromotion() {
      this.$router.push('/lanhu/chengguotuiguang');
    },
    navigateToFeature() {
      this.$router.push('/lanhu/chengguotese');
    },
    setHeaderPadding(val) {
      // 在下拉展开时动态增加头部底部留白，避免遮挡正文/左侧菜单
      this.headerPaddingBottom = Number(val) || 24;
    },
  },
  mounted() {
    // 组件挂载完成
  },
  beforeDestroy() {
    // 组件销毁前清理
  }
}
</script>

<style scoped>
/* 头部整体容器 */
.sh-header {
  width: 100%;
  background-color: transparent;
}
.sh-container {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(33, 81, 149, 1);
  padding: 0 40px;
  box-sizing: border-box;
}

/* 头部内容区域 */
.sh-header-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 头部图片 */
.sh-header-image {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  display: block;
  object-fit: contain;
}

/* ===== 导航样式（重新设计） ===== */
.section_1 { 
  position: relative; 
  z-index: 2000; 
  width: 43.7vw; 
  height: 2.08vw; 
  margin: 1.25vw auto 0 25vw !important; 
  display: flex;
  align-items: center; 
  justify-content: space-between; 
}

/* 统一的一级菜单项样式 */
.nav-item { 
  position: relative; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.08vw;
  width: auto;
  min-width: 3.5vw;
  padding: 0 0.5vw;
  font-size: 0.94vw;
  font-family: SourceHanSansCN-Bold;
  font-weight: 700;
  color: rgba(136, 136, 136, 1);
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  border-radius: 4px;
  box-sizing: border-box;
}

/* 首页特殊样式（当前页面） */
.text_3 {
  color: rgba(34, 34, 34, 1) !important;
  border-bottom: 2px solid #215195;
}

/* 悬浮效果 */
.nav-item:hover { 
  background-color: #215195;
  color: white !important;
  font-size: 1.04vw;
  padding: 0.1vw 0.6vw;
}

/* 下拉菜单容器 */
.dropdown-container { 
  position: relative; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.08vw;
  width: auto;
  min-width: 3.5vw;
}

/* 下拉菜单 */
.dropdown-menu { 
  position: absolute; 
  top: 100%; 
  left: 50%;
  transform: translateX(-50%);
  background: white; 
  border: 1px solid #ddd; 
  border-radius: 4px; 
  box-shadow: 0 2px 8px rgba(0,0,0,0.15); 
  z-index: 3000; 
  min-width: 120px; 
  padding: 4px 0; 
  pointer-events: auto; 
  margin-top: 2px;
  width: max-content;
  margin-left: 30px;
}

/* 下拉菜单项 */
.dropdown-item { 
  padding: 8px 16px; 
  cursor: pointer; 
  color: #333; 
  font-size: 14px; 
  transition: all 0.2s ease; 
  white-space: nowrap; 
  position: relative; 
  display: block;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}

/* 下拉菜单项悬浮效果 */
.dropdown-item:hover { 
  background-color: #215195; 
  color: white; 
  font-weight: 600; 
  font-size: 16px; 
}

.dropdown-item:active { 
  background-color: #1a3d7a; 
  color: white; 
}
</style>